// Mock data for MAGIC C PLUMBING website

export const services = [
  {
    id: 1,
    title: "24/7 Emergency Plumbing",
    description: "Round-the-clock emergency intervention for all your urgent plumbing needs. Our expert team is ready to respond immediately to leaks, burst pipes, and critical plumbing failures.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1575282366139-d605e098a825?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGVuZ2luZWVyJTIwY29uc3RydWN0aW9uJTIwc2FmZXR5JTIwaGVsbWV0JTIwY2xlYW4lMjBwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzYwMTY1OTZ8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Immediate response within 30 minutes",
      "Leak detection and repair",
      "Burst pipe emergency fixes",
      "24/7 availability, 365 days a year"
    ]
  },
  {
    id: 2,
    title: "Heating Installation & Repair",
    description: "Professional installation and maintenance of heating systems including heat pumps and boilers. Energy-efficient solutions tailored to your comfort needs.",
    icon: "Flame",
    image: "https://images.unsplash.com/photo-1650551182991-b07558247564",
    features: [
      "Heat pump installation",
      "Boiler repair and replacement",
      "System diagnostics and maintenance",
      "Energy efficiency optimization"
    ]
  },
  {
    id: 3,
    title: "Water Heater Installation",
    description: "Expert installation of electric and gas water heaters. We ensure optimal performance and energy efficiency for your hot water needs.",
    icon: "Droplets",
    image: "https://images.unsplash.com/photo-1619140099965-06d74aaf51fa",
    features: [
      "Electric water heater installation",
      "Gas water heater setup",
      "Tankless water heater options",
      "Maintenance and repair services"
    ]
  },
  {
    id: 4,
    title: "Bathroom Design & Renovation",
    description: "Complete bathroom transformation from concept to completion. Professional design services with 3D renderings, detailed technical plans, and premium materials. We bring your vision to life with expert craftsmanship.",
    icon: "Bath",
    image: "https://images.unsplash.com/photo-1743213992612-c15167c1b269?w=1200&q=85",
    features: [
      "3D design renderings and technical plans",
      "Complete plumbing overhaul",
      "Luxury fixture installation",
      "Custom tile and stonework",
      "Modern shower and bathtub systems",
      "Material selection consultation"
    ]
  },
  {
    id: 5,
    title: "Heating & Plumbing Systems Design",
    description: "Professional technical design and planning for heating and plumbing systems. CAD drawings, 3D renderings, heat pump layouts, and comprehensive engineering solutions for residential and commercial projects.",
    icon: "FileText",
    image: "https://images.unsplash.com/photo-1721244654392-9c912a6eb236?w=1200&q=85",
    features: [
      "CAD drawings and technical blueprints",
      "3D system renderings and visualization",
      "Heat pump and HVAC layout design",
      "Plumbing system engineering plans",
      "Energy efficiency calculations",
      "Compliance and regulatory documentation"
    ]
  },
  {
    id: 6,
    title: "Solar Thermal Panel Installation",
    description: "Harness renewable energy with professional solar thermal panel installation. Reduce your energy costs while protecting the environment.",
    icon: "Sun",
    image: "https://images.unsplash.com/photo-1668097613572-40b7c11c8727",
    features: [
      "Solar thermal system design",
      "Professional installation",
      "Integration with existing systems",
      "Maintenance and monitoring"
    ]
  }
];

export const commercialProjects = [
  {
    id: 1,
    title: "Hotels & Hospitality",
    description: "Complete plumbing and heating systems for hotels, restaurants, and luxury accommodations",
    icon: "Building2",
    projects: "50+ Completed"
  },
  {
    id: 2,
    title: "Commercial Buildings",
    description: "Office complexes, retail spaces, and commercial developments with comprehensive solutions",
    icon: "Building",
    projects: "120+ Projects"
  },
  {
    id: 3,
    title: "New Build Developments",
    description: "Full plumbing infrastructure for residential and commercial new builds from ground up",
    icon: "Construction",
    projects: "80+ Developments"
  },
  {
    id: 4,
    title: "Healthcare Facilities",
    description: "Specialized plumbing for hospitals, clinics, and healthcare centers with strict compliance",
    icon: "Heart",
    projects: "25+ Facilities"
  },
  {
    id: 5,
    title: "Educational Institutions",
    description: "Schools, universities, and training centers with efficient and safe plumbing systems",
    icon: "GraduationCap",
    projects: "40+ Institutions"
  },
  {
    id: 6,
    title: "Industrial & Manufacturing",
    description: "Heavy-duty plumbing for factories, warehouses, and industrial facilities",
    icon: "Factory",
    projects: "30+ Sites"
  }
];

export const heatingDesignServices = [
  {
    id: 1,
    title: "Heat Pump System Design",
    description: "Custom heat pump solutions designed for maximum efficiency and comfort",
    icon: "Wind"
  },
  {
    id: 2,
    title: "Underfloor Heating Design",
    description: "Luxurious underfloor heating systems for optimal warmth distribution",
    icon: "Thermometer"
  },
  {
    id: 3,
    title: "Gas & Electric Heating Systems",
    description: "Comprehensive heating solutions tailored to your property needs",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Hot Water System Design",
    description: "Efficient hot water systems ensuring constant supply",
    icon: "Droplets"
  },
  {
    id: 5,
    title: "Complete Plumbing System Layouts",
    description: "Full system design and planning for new builds and renovations",
    icon: "Layout"
  },
  {
    id: 6,
    title: "Technical Drawings & 3D Plans",
    description: "Detailed technical documentation and 3D visualizations",
    icon: "FileText"
  }
];

export const smartFeatures = [
  {
    id: 1,
    title: "Energy & Water Savings",
    description: "Reduce utility bills by up to 40% with smart plumbing technology and efficient fixtures",
    icon: "Leaf",
    stat: "40%"
  },
  {
    id: 2,
    title: "Environmental Benefits",
    description: "Lower carbon footprint with eco-friendly systems and sustainable practices",
    icon: "TreePine",
    stat: "CO₂ ↓"
  },
  {
    id: 3,
    title: "Modern Technology",
    description: "Smart thermostats, leak detection sensors, and automated water management",
    icon: "Smartphone",
    stat: "24/7"
  },
  {
    id: 4,
    title: "Future-Proof Solutions",
    description: "Cutting-edge systems designed to meet tomorrow's efficiency standards",
    icon: "TrendingUp",
    stat: "100%"
  }
];

export const maintenancePackages = [
  {
    id: 1,
    type: "Residential",
    title: "Home Care Package",
    price: "£299/year",
    features: [
      "Annual boiler service",
      "Plumbing system inspection",
      "Priority emergency callout",
      "10% discount on repairs",
      "Safety certificate included"
    ],
    popular: false
  },
  {
    id: 2,
    type: "Residential",
    title: "Premium Home Package",
    price: "£499/year",
    features: [
      "Bi-annual boiler service",
      "Full system health check",
      "24/7 priority emergency response",
      "20% discount on all repairs",
      "Free minor repairs (up to £100)",
      "Annual bathroom inspection"
    ],
    popular: true
  },
  {
    id: 3,
    type: "Commercial",
    title: "Business Package",
    price: "Custom Quote",
    features: [
      "Quarterly system inspections",
      "24/7 emergency response",
      "Dedicated account manager",
      "Predictive maintenance planning",
      "All certifications included",
      "Flexible payment terms"
    ],
    popular: false
  }
];

export const carouselImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3NzU5OTI1MzV8MA&ixlib=rb-4.1.0&q=85",
    title: "Modern Luxury",
    caption: "Contemporary elegance meets functionality"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3NzU5OTI1MzV8MA&ixlib=rb-4.1.0&q=85",
    title: "Spa Sanctuary",
    caption: "Your personal wellness retreat"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3NzU5OTI1MzV8MA&ixlib=rb-4.1.0&q=85",
    title: "Timeless Classic",
    caption: "Sophisticated design that endures"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3NzU5OTI1MzV8MA&ixlib=rb-4.1.0&q=85",
    title: "Natural Harmony",
    caption: "Organic materials in perfect balance"
  },
  {
    id: 5,
    url: "https://images.pexels.com/photos/6934233/pexels-photo-6934233.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Premium Finishes",
    caption: "Exquisite details, exceptional quality"
  }
];

export const galleryVideos = [
  // === OUTDOOR LUXURY & BALI-STYLE BATHROOMS ===
  {
    id: 1,
    title: "Outdoor Bali-Style Bathroom with Ocean View",
    thumbnail: "https://images.unsplash.com/photo-1743213992612-c15167c1b269?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Outdoor Luxury",
    duration: "3:15"
  },
  {
    id: 2,
    title: "Tropical Garden Bathtub Installation",
    thumbnail: "https://images.unsplash.com/photo-1635318414376-fd3fcdf9937a?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Outdoor Luxury",
    duration: "2:45"
  },
  {
    id: 3,
    title: "Natural Stone Outdoor Bathroom Project",
    thumbnail: "https://images.unsplash.com/photo-1689917781910-ac9115b77d27?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Outdoor Luxury",
    duration: "2:30"
  },
  {
    id: 4,
    title: "Luxury Ocean-View Bathtub Installation",
    thumbnail: "https://images.unsplash.com/photo-1585576207154-7a6daca0a92c?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Outdoor Luxury",
    duration: "3:00"
  },
  
  // === LONDON LUXURY BATHROOMS ===
  {
    id: 5,
    title: "Chelsea Townhouse Bathroom Renovation",
    thumbnail: "https://images.unsplash.com/photo-1615580064300-7f38da8aaa97?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "London Luxury",
    duration: "2:50"
  },
  {
    id: 6,
    title: "Kensington Apartment Marble Bathroom",
    thumbnail: "https://images.unsplash.com/photo-1764551322786-54a994923d8f?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "London Luxury",
    duration: "2:20"
  },
  {
    id: 7,
    title: "Notting Hill Luxury Bathroom Design",
    thumbnail: "https://images.unsplash.com/photo-1657114012245-cfa18766a58a?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "London Luxury",
    duration: "3:10"
  },
  
  // === COMMERCIAL & PROFESSIONAL PROJECTS ===
  {
    id: 8,
    title: "5-Star Hotel Bathroom Suite Installation",
    thumbnail: "https://images.unsplash.com/photo-1668150078766-552812c75ce2?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Commercial Projects",
    duration: "3:30"
  },
  {
    id: 9,
    title: "Luxury Spa & Wellness Center",
    thumbnail: "https://images.unsplash.com/photo-1728486884112-e6e5d7ccfea5?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Commercial Projects",
    duration: "2:45"
  },
  {
    id: 10,
    title: "High-End Restaurant Bathroom Renovation",
    thumbnail: "https://images.unsplash.com/photo-1764475501545-d5cc9719af1a?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Commercial Projects",
    duration: "2:15"
  },
  {
    id: 11,
    title: "Premium Corporate Office Restrooms",
    thumbnail: "https://images.unsplash.com/photo-1765745518752-68a289300789?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Commercial Projects",
    duration: "2:00"
  },
  {
    id: 12,
    title: "Boutique Hotel Bathroom Design",
    thumbnail: "https://images.unsplash.com/photo-1650532897813-d92427f7d229?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Commercial Projects",
    duration: "2:55"
  },
  
  // === MODERN BATHROOM TRANSFORMATIONS ===
  {
    id: 13,
    title: "Contemporary Marble Bathroom",
    thumbnail: "https://images.unsplash.com/photo-1744025098626-66c0b9cb1ba8?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Modern Renovations",
    duration: "2:30"
  },
  {
    id: 14,
    title: "Minimalist Luxury Shower Installation",
    thumbnail: "https://images.unsplash.com/photo-1621215058889-885f3d5a143c?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Modern Renovations",
    duration: "1:45"
  },
  
  // === HEATING & PLUMBING SYSTEMS ===
  {
    id: 15,
    title: "Solar Panel Installation",
    thumbnail: "https://images.unsplash.com/photo-1668097613572-40b7c11c8727?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Solar Installation",
    duration: "4:00"
  },
  {
    id: 16,
    title: "Heating System Modernization",
    thumbnail: "https://images.unsplash.com/photo-1650551182991-b07558247564?w=800&q=80",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    category: "Heating",
    duration: "2:50"
  }
];

export const galleryItems = [
  {
    id: 1,
    title: "Modern Bathroom Transformation",
    before: "https://images.unsplash.com/photo-1638799869566-b17fa794c4de",
    after: "https://images.unsplash.com/photo-1774578341998-d1e9a74e82f6",
    category: "Bathroom Renovation"
  },
  {
    id: 2,
    title: "Luxury Shower Installation",
    before: "https://images.unsplash.com/photo-1542013936693-884638332954",
    after: "https://images.unsplash.com/photo-1758448018619-4cbe2250b9ad",
    category: "Bathroom Renovation"
  },
  {
    id: 3,
    title: "Contemporary Vanity Upgrade",
    before: "https://images.unsplash.com/photo-1749532125405-70950966b0e5",
    after: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d",
    category: "Bathroom Renovation"
  },
  {
    id: 4,
    title: "Solar Panel Installation",
    before: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d",
    after: "https://images.unsplash.com/photo-1668097613572-40b7c11c8727",
    category: "Solar Installation"
  },
  {
    id: 5,
    title: "Heating System Modernization",
    before: "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg",
    after: "https://images.unsplash.com/photo-1650551182991-b07558247564",
    category: "Heating"
  },
  {
    id: 6,
    title: "Premium Fixture Installation",
    before: "https://images.unsplash.com/photo-1774578342098-66adff9c1fe1",
    after: "https://images.unsplash.com/photo-1773177930292-463ca3c5b86a",
    category: "Plumbing"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Homeowner",
    content: "MAGIC C PLUMBING transformed our outdated bathroom into a modern luxury spa. Their attention to detail and professionalism exceeded our expectations.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
  },
  {
    id: 2,
    name: "James Peterson",
    role: "Property Manager",
    content: "When we had an emergency pipe burst at 2 AM, they arrived within 20 minutes. Exceptional 24/7 service that saved us from major water damage.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Business Owner",
    content: "The solar thermal installation has cut our energy costs significantly. Professional installation and excellent follow-up service.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
  }
];

export const stats = [
  { label: "Years Experience", value: "15+" },
  { label: "Projects Completed", value: "2,500+" },
  { label: "Happy Clients", value: "1,800+" },
  { label: "Team Members", value: "25+" }
];

export const quoteFormData = {
  services: [
    "Emergency Plumbing",
    "Heating Installation",
    "Water Heater Installation",
    "Bathroom Renovation",
    "Bathroom Design",
    "Solar Panel Installation",
    "Heating & Plumbing System Design",
    "Smart Plumbing Solutions",
    "Annual Maintenance Contract",
    "Other"
  ],
  urgency: [
    "Emergency (within 24h)",
    "Urgent (within 1 week)",
    "Standard (within 1 month)",
    "Planning (over 1 month)"
  ]
};
